/* lt-app.js — Laser Tags page interactions */
(function () {
  if (window.__ltInit) return; window.__ltInit = true;

  function money(cents) {
    var fmt = (window.LT && window.LT.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.'));
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lt-reveal,.lt-story-media,.lt-card,.lt-steps');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initHeader() {
    var h = document.querySelector('.lt-header'); if (!h) return;
    var on = function () { h.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', on, { passive: true }); on();
  }

  function initTilt() {
    if (!window.matchMedia('(hover:hover)').matches) return;
    document.querySelectorAll('[data-lt-tilt]').forEach(function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        c.style.transform = 'perspective(900px) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 7) + 'deg) translateY(-4px)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  function initGallery(g) {
    var slides = g.querySelectorAll('.lt-slide'), thumbs = g.querySelectorAll('.lt-thumb'), i = 0, timer;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); var v = s.querySelector('video'); if (v) { k === i ? v.play().catch(function(){}) : v.pause(); } });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    function auto() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 4500); }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); auto(); }); });
    var p = g.querySelector('.lt-stage-nav--prev'), n = g.querySelector('.lt-stage-nav--next');
    if (p) p.addEventListener('click', function () { go(i - 1); auto(); });
    if (n) n.addEventListener('click', function () { go(i + 1); auto(); });
    var sx = null, st = g.querySelector('.lt-stage');
    st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    st.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); auto(); } sx = null; });
    g.__ltGo = function (mediaId) { slides.forEach(function (s, k) { if (s.dataset.mediaId === String(mediaId)) go(k); }); };
    auto();
  }

  function initBuy(form) {
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-lt-qty]');
    var priceEls = document.querySelectorAll('[data-lt-btn-price]');
    var tiers = form.querySelectorAll('.lt-tier');
    var gallery = document.querySelector('.lt-gallery');

    function select(t) {
      tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
      var inp = t.querySelector('input'); inp.checked = true;
      idInput.value = t.dataset.variantId;
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      priceEls.forEach(function (el) { el.textContent = money(parseInt(t.dataset.price, 10) * q); });
      document.querySelectorAll('[data-lt-sticky-name]').forEach(function (el) { el.textContent = t.dataset.name; });
      document.querySelectorAll('[data-lt-sticky-price]').forEach(function (el) { el.textContent = money(parseInt(t.dataset.price, 10)); });
      document.querySelectorAll('[data-lt-sticky-compare]').forEach(function (el) { var c = parseInt(t.dataset.compare, 10); el.textContent = c > parseInt(t.dataset.price, 10) ? money(c) : ''; });
      if (t.dataset.mediaId && gallery && gallery.__ltGo) gallery.__ltGo(t.dataset.mediaId);
      try { var u = new URL(location.href); u.searchParams.set('variant', t.dataset.variantId); history.replaceState(null, '', u); } catch (e) {}
    }
    tiers.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); select(t); }); });

    form.querySelectorAll('[data-lt-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, Math.min(10, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.ltStep, 10)));
        qtyInput.value = v; var sel = form.querySelector('.lt-tier.is-selected'); if (sel) select(sel);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(idInput.value, parseInt(qtyInput && qtyInput.value, 10) || 1, form.querySelector('[data-lt-submit]'), (form.closest('[data-after]')||{dataset:{}}).dataset.after);
    });
    var sel = form.querySelector('.lt-tier.is-selected') || tiers[0]; if (sel) select(sel);
  }

  function addToCart(id, qty, btn, after) {
    if (btn) btn.classList.add('is-loading');
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = after === 'cart' ? '/cart' : '/checkout'; })
      .catch(function () { window.location.href = '/cart/' + id + ':' + qty; });
  }

  function initSticky() {
    var s = document.querySelector('.lt-sticky'), anchor = document.querySelector('[data-lt-buy-anchor]');
    if (s && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; s.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
    }
    document.querySelectorAll('[data-lt-buy-now]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var form = document.querySelector('form.lt-form');
        if (b.dataset.ltBuyNow === 'scroll' || !form) {
          var target = document.getElementById('lt-buy');
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          return;
        }
        e.preventDefault();
        var q = form.querySelector('[data-lt-qty]');
        addToCart(form.querySelector('input[name="id"]').value, parseInt(q && q.value, 10) || 1, b, (form.closest('[data-after]')||{dataset:{}}).dataset.after);
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-lt-faq]').forEach(function (list) {
      var ds = list.querySelectorAll('details');
      ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    });
  }

  function boot() {
    initReveal(); initHeader(); initTilt(); initFaq();
    document.querySelectorAll('.lt-gallery').forEach(initGallery);
    document.querySelectorAll('form.lt-form').forEach(initBuy);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); e.target.querySelectorAll('.lt-reveal').forEach(function (x) { x.classList.add('is-in'); }); });
})();
